export const ZOOM_IN_STATE = '@/ZOOM_IN_STATE';
export const ZOOM_OUT_STATE = '@/ZOOM_OUT_STATE';
export const ZOOM_PAGE_EDIT_STATE = '@/ZOOM_PAGE_EDIT_STATE';

export const ZOOM_VALUES = {
    MIN_VALUE: 25,
    MAX_VALUE: 400,
    DEFAULT_VALUE: 100,
    STEP: 5,
}